import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AdminNavbar from 'components/Navbars/AdminNavbar'
import AlertDialog from 'components/AlertDialog'
import MainButton from 'components/Buttons/MainButton'
import submitOnEnter from 'utils/submitOnEnter'
import categoryValidator from 'validators/Admin/categoryValidator'
import { Formik } from 'formik'

import {
  Container,
  Form,
  FormField,
  Title,
  Input,
  Row,
  InfoText,
  WarningText,
  ErrorContainer
} from './styles'

export default function NewServiceCategory () {
  const [errorMessage, setErrorMessage] = useState (null)
  const [showOkDialog, setShowOkDialog] = useState (false)
  const token = AuthService.getToken ()
  const navigate = useNavigate ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const toggleOkDialog = () => setShowOkDialog (!showOkDialog)

  return (
    <Container>
      <AdminNavbar/>
      <Formik
        validationSchema={categoryValidator}
        initialValues={{
          'name': '',
          'description': ''
        }}
        onSubmit={async (values, { setSubmitting }) => {

          try {
            await cutileiApi.post ('/service_categories', values, requestConfig)

            setSubmitting (false)
            toggleOkDialog ()
          } catch (error) {
            setSubmitting (false)
            logApiError (error)
          }
        }}
      >
        {({
          values,
          errors,
          touched,
          isSubmitting,
          handleChange,
          handleBlur,
          handleSubmit
        }) => (
          <Form onKeyDown={submitOnEnter(handleSubmit, isSubmitting)}>
            <Title>Cadastrar categoria de serviço</Title>
            <Row>
              <FormField>
                <Input 
                  placeholder='Nome'
                  value={values.name}
                  onChange={handleChange ('name')} 
                  onBlur={handleBlur ('name')}
                />
                {touched.name && errors.name && (
                  <WarningText>
                    {errors.name}
                  </WarningText>
                )}
              </FormField>
            </Row>
            <Row>
              <FormField>
                <Input 
                  placeholder='Descrição'
                  value={values.description}
                  onChange={handleChange ('description')} 
                  onBlur={handleBlur ('description')}
                />
                {touched.description && errors.description && (
                  <WarningText>
                    {errors.description}
                  </WarningText>
                )}
              </FormField>
            </Row>
            {errorMessage && (
              <ErrorContainer>
                <InfoText>{errorMessage}</InfoText>
              </ErrorContainer>
            )}
            <AlertDialog
              visible={showOkDialog}
              title='Sucesso'
              message='Categoria cadastrada!'
              confirmText='Ok'
              onConfirm={() => navigate ('/admin/config', { replace: true })}
              onClose={() => navigate ('/admin/config', { replace: true })}
            />
            <MainButton
              label='Criar categoria'
              onClick={handleSubmit}
              disabled={isSubmitting}
              loading={isSubmitting}
              width={180}
            />
          </Form>
        )}
      </Formik>
    </Container>
  )
}
